import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { findDOMNode } from 'react-dom';
import { ButtonV2 } from '@zola/zola-ui';

// These versions of the form components match the ones in Web-registry.  TODO: add to zola-ui if possible.

// RENDER SUBMIT BUTTON
export const RenderSubmitButtonV2 = props => {
  const {
    pristine,
    submitting,
    valid,
    className,
    value,
    hideFormGroup,
    disableWhenPristine,
    showSuccess,
    disabled,
    successText,
    onClick,
    submitButtonText,
  } = props;
  const disable = disabled || !valid || showSuccess || (disableWhenPristine && pristine);
  const buttonText = showSuccess ? successText || 'Saved' : value || 'Save';
  return (
    <div className={`${hideFormGroup ? '' : 'form-group'}`}>
      {submitting ? (
        <ButtonV2 type="submit" className={className} disabled={disable} onClick={onClick}>
          <span>{submitButtonText}</span>
          <div className="loader" />
        </ButtonV2>
      ) : (
        <ButtonV2 type="submit" className={className} disabled={disable} onClick={onClick}>
          {showSuccess && <i className="zolaicon zolaicon-checkmark" />} {buttonText}
        </ButtonV2>
      )}
    </div>
  );
};

RenderSubmitButtonV2.propTypes = {
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  valid: PropTypes.bool.isRequired,
  className: PropTypes.string,
  value: PropTypes.string,
  hideFormGroup: PropTypes.bool,
  disableWhenPristine: PropTypes.bool,
  showSuccess: PropTypes.bool,
  disabled: PropTypes.bool,
  successText: PropTypes.string,
  onClick: PropTypes.func,
  submitButtonText: PropTypes.string,
};

RenderSubmitButtonV2.defaultProps = {
  disableWhenPristine: false,
  showSuccess: false,
  submitting: false,
};

export class RenderDropdownSelectV2 extends Component {
  constructor(props) {
    super(props);

    this.onWindowClick = this.onWindowClick.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.updateField = this.updateField.bind(this);
    this.setActiveField = this.setActiveField.bind(this);
    this.findLabel = this.findLabel.bind(this);
    this.hide = this.hide.bind(this);

    const { value } = props.input;
    this.state = {
      isOpen: false,
      activeField: value,
      touchedOverride: false,
      isClosed: false,
    };
  }

  componentDidMount() {
    window.addEventListener('click', this.onWindowClick);
    window.addEventListener('touchstart', this.onWindowClick);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick);
    window.removeEventListener('touchstart', this.onWindowClick);
  }

  onWindowClick(e) {
    const { isOpen } = this.state;
    const dropdownElement = findDOMNode(this); // eslint-disable-line
    if (e.target !== dropdownElement && !dropdownElement.contains(e.target) && isOpen) {
      this.hide();
    }
  }

  setActiveField(activeField) {
    this.setState({
      activeField,
    });
  }

  updateField(value) {
    const { input } = this.props;
    input.onChange(value);
    this.setActiveField(value);
    this.setState({ touchedOverride: true });
  }

  toggleDropdown() {
    const { input, handleToggleDropdown } = this.props;
    const { value } = input.value;
    const activeField = value;
    if (handleToggleDropdown) {
      handleToggleDropdown(input.name);
    }
    this.setState(
      state => ({
        isOpen: !state.isOpen,
        activeField,
      }),
      () => {
        const { isOpen } = this.state;
        if (!isOpen) {
          this.setState({
            isClosed: true,
          });
        } else {
          this.setState({
            isClosed: false,
          });
        }
        const activeEl = document.getElementById(activeField);
        if (activeEl) {
          this.selectDropdown.scrollTop = activeEl.offsetTop - 80;
        }
      }
    );
  }

  findLabel(value) {
    const { options } = this.props;
    const selectedOption = _.find(options, { value: value }); // eslint-disable-line
    if (selectedOption) {
      return selectedOption.title;
    }
    return null;
  }

  hide() {
    this.setState({
      isOpen: false,
      isClosed: true,
    });
    const { handleToggleDropdown, input } = this.props;
    if (handleToggleDropdown) {
      handleToggleDropdown(input.name);
    }
  }

  render() {
    const {
      cb,
      options,
      input,
      label,
      id,
      required,
      hideFormGroup,
      hideEmpty,
      selectText,
      maxHeight,
      tooltip,
      meta: { touched, error },
      placeholder,
      disabled,
      showToggleAnimation,
    } = this.props;
    const { isOpen, isClosed, activeField, touchedOverride } = this.state;

    return (
      <div
        className={`${hideFormGroup ? '' : 'form-group'} ${
          (touched || touchedOverride) && error ? 'has-error' : ''
        }`}
      >
        {label && (
          <label htmlFor={id}>
            {tooltip ? (
              <span>
                {label} {required && <span className="text-danger danger-asterisk">*</span>}
              </span>
            ) : (
              <span>
                {label} {required && <span className="text-danger danger-asterisk">*</span>}
              </span>
            )}
          </label>
        )}
        <div
          id={id}
          className={`scroll-select ${(touched || touchedOverride) && error ? 'has-error' : ''} ${
            tooltip ? 'with-tooltip' : ''
          } ${isOpen ? 'scroll-select-active' : ''} ${disabled ? 'scroll-select-disabled' : ''}`}
          data-tooltip={tooltip}
          onClick={() => {
            if (!disabled) {
              this.toggleDropdown();
            }
          }}
        >
          <div className="btn btn-dropdown btn-boxed">
            {input.value === '' ? (
              <span className="scroll-value">{placeholder || 'Select...'}</span>
            ) : (
              <span className={`scroll-value ${input.value ? 'scroll-value-chosen' : ''}`}>
                {this.findLabel(input.value) || placeholder || 'Select...'}
              </span>
            )}
            {showToggleAnimation && (
              <span
                className={classNames(
                  { 'zolaicon-chevron-closed': isClosed },
                  { 'zolaicon-chevron-open': isOpen }
                )}
              >
                <i className="zolaicon zolaicon-chevron-down" />
              </span>
            )}
            {!showToggleAnimation && (
              <i
                className={classNames(
                  'zolaicon',
                  { 'zolaicon-chevron-up': isOpen },
                  { 'zolaicon-chevron-down': !isOpen }
                )}
              />
            )}
          </div>
          <div
            className="scroll-select-dropdown"
            style={{
              display: isOpen ? 'block' : 'none',
              maxHeight: maxHeight ? `${maxHeight}px` : '',
            }}
            ref={selectDropdown => {
              this.selectDropdown = selectDropdown;
            }}
          >
            {!hideEmpty && (
              <div
                id={`${input.name}-empty`}
                className={`scroll-select-option scroll-select-empty ${
                  activeField === `${input.name}-empty` ? 'scroll-select-active' : ''
                }`}
                onClick={() => this.updateField('')}
                onMouseEnter={() => this.setActiveField(`${input.name}-empty`)}
              >
                {selectText || 'Select...'}
              </div>
            )}
            {options.map(opt => (
              <div
                id={opt.value}
                key={opt.value}
                className={`scroll-select-option ${
                  activeField === opt.value ? 'scroll-select-active' : ''
                }`}
                onClick={() => {
                  this.updateField(opt.value);
                  if (cb) cb(opt.value);
                }}
                onMouseEnter={() => this.setActiveField(opt.value)}
              >
                {opt.title}
              </div>
            ))}
          </div>
        </div>
        {(touched || touchedOverride) && error && <span className="help-block">{error}</span>}
      </div>
    );
  }
}

RenderDropdownSelectV2.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
  }),
  options: PropTypes.arrayOf(PropTypes.shape({})),
  label: PropTypes.string,
  id: PropTypes.string,
  required: PropTypes.bool,
  hideFormGroup: PropTypes.bool,
  hideEmpty: PropTypes.bool,
  selectText: PropTypes.string,
  maxHeight: PropTypes.number,
  tooltip: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  placeholder: PropTypes.string,
  cb: PropTypes.func,
  disabled: PropTypes.bool,
  handleToggleDropdown: PropTypes.func,
  showToggleAnimation: PropTypes.bool,
};

// RENDER FIELD
export const RenderField = ({
  input,
  label,
  labelClass,
  type,
  id,
  required,
  placeholder,
  disabled,
  inputGroup,
  onBlurFunction,
  maxChars,
  className,
  hideFormGroup,
  helpMessage,
  showCharacterCount,
  meta: { touched, error, asyncValidating },
  autoFocus,
  onKeyDown,
  min,
  max,
  step,
  icon,
}) => {
  const getClassName = () => {
    let containerClassName = '';

    if (inputGroup) {
      containerClassName = 'input-group';
    } else if (icon) {
      containerClassName = 'icon-group has-feedback has-feedback-left';
    } else {
      containerClassName = '';
    }
    return containerClassName;
  };

  return (
    <div
      className={`${hideFormGroup ? '' : 'form-group'}${touched && error ? ' has-error' : ''} ${
        className || ''
      }`}
    >
      {label && (
        <label htmlFor={id} className={labelClass}>
          {label} {required && <span className="text-danger danger-asterisk">*</span>}
        </label>
      )}
      <div className={getClassName()}>
        {icon && <i className="zolaicon zolaicon-link form-control-feedback link-icon" />}
        {inputGroup && <span className="input-group-addon">{inputGroup}</span>}
        <input
          {...input}
          className="form-control"
          type={type}
          id={id}
          placeholder={placeholder}
          disabled={disabled}
          autoFocus={autoFocus}
          onBlur={e => {
            if (onBlurFunction) {
              onBlurFunction(input.value);
            }
            input.onBlur(e);
          }}
          onKeyDown={onKeyDown}
          min={min}
          max={max}
          step={step}
        />
        {maxChars && !inputGroup && (
          <span
            className={`pull-right char-count text-${
              input.value.length <= maxChars ? 'muted' : 'danger'
            } ${
              input.value.length < maxChars - maxChars / 10 && !showCharacterCount ? 'hidden' : ''
            }`}
          >
            {input.value.length}/{maxChars}
          </span>
        )}
        {helpMessage && !inputGroup && <small className="text-muted">{helpMessage}</small>}
        {touched && error && <span className="help-block">{error}</span>}
        {asyncValidating && <span className="help-block">Checking availability...</span>}
      </div>
      {maxChars && (inputGroup || icon) && (
        <span
          className={`pull-right char-count text-${
            input.value.length <= maxChars ? 'muted' : 'danger'
          } ${
            input.value.length < maxChars - maxChars / 10 && !showCharacterCount ? 'hidden' : ''
          }`}
        >
          {input.value.length}/{maxChars}
        </span>
      )}
      {helpMessage && (inputGroup || icon) && <small className="text-muted">{helpMessage}</small>}
    </div>
  );
};

RenderField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
  }).isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  labelClass: PropTypes.string,
  type: PropTypes.oneOf([
    'text',
    'email',
    'password',
    'tel',
    'number',
    'url',
    'search',
    'date',
    'time',
  ]).isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  inputGroup: PropTypes.string,
  onBlurFunction: PropTypes.func,
  maxChars: PropTypes.number,
  min: PropTypes.string,
  max: PropTypes.string,
  step: PropTypes.string,
  className: PropTypes.string,
  hideFormGroup: PropTypes.bool,
  helpMessage: PropTypes.string,
  showCharacterCount: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    asyncValidating: PropTypes.bool,
  }),
  autoFocus: PropTypes.bool,
  onKeyDown: PropTypes.func,
  icon: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/common/form/indexV2.jsx